import React, { useState, useEffect } from 'react';
import './SplashScreen.css';

const SplashScreen = ({ onFinish }) => {
  const [isVisible, setIsVisible] = useState(true);
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    // ३.५ सेकंद दाखव
    const showTimer = setTimeout(() => {
      setFadeOut(true);
      
      // fade out पूर्ण होण्यासाठी थोडा वेळ
      const fadeTimer = setTimeout(() => {
        setIsVisible(false);
        onFinish(); // मुख्य पेज दाखव
      }, 1000);
      
      return () => clearTimeout(fadeTimer);
    }, 3500);

    return () => clearTimeout(showTimer);
  }, [onFinish]);

  if (!isVisible) return null;

  return (
    <div className={`splash-screen ${fadeOut ? 'fade-out' : ''}`}>
      <div className="splash-content">
        <img
          src="/images/sj1.jpg"           // तुझा logo path (public/images मध्ये ठेव)
          alt="ग्रामपंचायत कापशी"
          className="splash-logo"
        />
        <h1>स्वागत आहे!</h1>
        <h2>ग्रामपंचायत कापशी</h2>
        <p>पंचायत समिती डहाणू, जिल्हा पालघर</p>
        <div className="loading-bar">
          <div className="progress"></div>
        </div>
      </div>
    </div>
  );
};

export default SplashScreen;